export enum MassArrivalStatus {
  Critical = 1,
  NearCapacity = 2,
  Ok = 3,
  WithoutProgramming = 4,
}